import React from 'react';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';
import { moodifyContent } from '../rich-content/moodify-complete-content';

const moodifyDetailPage = () => {
  return <AutomaticPageBuilder content={moodifyContent} />;
};

export default moodifyDetailPage;